module.exports = __webpack_public_path__ + "static/media/cc.2643c11a.svg";